const translation = {
  'message.join_message': `Hey! Listen! {name} has joined!`,
  'message.channel': `Message {channel}`,
  'header.join': `Join`
}

export default translation



// WEBPACK FOOTER //
// ./src/app/locales/translations/en.ts